<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama Agenda" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Agenda
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Agenda"

                      hide-details

                      v-model="form.title"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.title !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <v-row>
                    <v-col cols="6">
                      <ValidationProvider
                        name="Tanggal Mulai" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Tanggal Mulai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. 2021-01-01"

                          hide-details
                          type="date"

                          v-model="form.start_date"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.start_date !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6">
                      <ValidationProvider
                        name="Tanggal Selesai" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Tanggal Selesai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. 2021-01-01"

                          hide-details
                          type="date"

                          v-model="form.end_date"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.end_date !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>


                    <v-col cols="6">
                      <ValidationProvider
                        name="Waktu Mulai" 
                        rules="" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <!-- <span class="red--text">*</span> -->
                          Waktu Mulai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. 10:00"

                          hide-details
                          type="time"

                          v-model="form.start_time"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.start_time !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6">
                      <ValidationProvider
                        name="Waktu Selesai" 
                        rules="" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <!-- <span class="red--text">*</span> -->
                          Waktu Selesai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. 10:00"

                          hide-details
                          type="time"

                          v-model="form.end_time"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.end_time !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <!-- <v-row>
                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal Mulai
                      </div>
    
                      <v-menu
                        v-model="date.start"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Tanggal Mulai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.start_date"
                              placeholder="Pilih Tanggal Mulai"
                              hide-details
                              :color="set_color"
                              readonly
                              filled
                              rounded
                              dense
                              required
                              v-bind="attrs"
                              v-on="on"
                              :success="form.start_date !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.start_date !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-date-picker
                          v-model="form.start_date"
                          :color="set_color"
                          @input="form.start_time = ''; form.end_date = ''; form.end_time = ''; date.start = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Waktu Mulai
                      </div>
    
                      <v-menu
                        ref="start"
                        v-model="time.start"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.start_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Waktu Mulai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.start_time"
                              placeholder="Pilih Waktu Mulai"
                              hide-details
                              :color="set_color"
                              readonly
                              filled
                              rounded
                              dense
                              required
                              v-bind="form.start_date === '' ? '' : attrs"
                              v-on="form.start_date === '' ? '' : on"
                              :success="form.start_time !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.start_time !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-time-picker
                          v-model="form.start_time"
                          full-width
                          format="24hr"
                          :color="set_color"
                          v-if="time.start"
                          @click:minute="$refs.start.save(form.start_time)"
                          @input="form.end_date = ''; form.end_time = '';"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal Selesai
                      </div>
    
                      <v-menu
                        v-model="date.end"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Tanggal Selesai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.end_date"
                              placeholder="Pilih Tanggal Selesai"
                              hide-details
                              :color="set_color"
                              readonly
                              filled
                              rounded
                              dense
                              required
                              v-bind="form.start_time === '' ? '' : attrs"
                              v-on="form.start_time === '' ? '' : on"
                              :success="form.end_date !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.end_date !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-date-picker
                          v-model="form.end_date"
                          :color="set_color"
                          :min="form.start_date"
                          @input="form.end_time = ''; date.end = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Waktu Selesai
                      </div>
    
                      <v-menu
                        ref="end"
                        v-model="time.end"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.end_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Waktu Selesai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.end_time"
                              placeholder="Pilih Waktu Selesai"
                              hide-details
                              :color="set_color"
                              readonly
                              v-bind="form.end_date === '' ? '' : attrs"
                              v-on="form.end_date === '' ? '' : on"
                              filled
                              rounded
                              dense
                              required
                              :success="form.end_time !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.end_time !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-time-picker
                          v-model="form.end_time"
                          full-width
                          format="24hr"
                          :color="set_color"
                          v-if="time.end"
                          :min="form.end_date === form.start_date ? form.start_time : ''"
                          @click:minute="$refs.end.save(form.end_time)"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row> -->

                  <ValidationProvider
                    name="Pilih Pengguna" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Pengguna
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih Pengguna"

                      :items="unitWithOther"
                      item-text="title"
                      item-value="title"
                      hide-details

                      v-model="form.dihadiri"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.dihadiri !== '' && valid && form.dihadiri !== 'Lainnya'">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    v-if="form.dihadiri === 'Lainnya'"
                    name="Lainnya" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <!-- <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Tuliskan Lainnya
                    </div> -->

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Dinas Komunikasi dan Informatika"

                      hide-details

                      v-model="form.custom_opd"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.custom_opd !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Tempat Agenda" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Tempat Agenda
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
                      :items="product"
                      item-text="name"
                      item-value="name"

                      :color="set_color"
                      placeholder="Contoh. Alun-alun Klaten"

                      hide-details

                      v-model="form.location"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.location !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <!-- <ValidationProvider
                    name="Deskripsi" 
                    rules="required" 
                    v-slot="{ errors, valid }"> -->
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      Deskripsi
                    </div>
                    <v-textarea
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
                      rows="3"

                      :color="set_color"
                      placeholder="Contoh. Tuliskan deskripsi disini . . ."

                      hide-details

                      v-model="form.desc"
                      class="mb-2"
                      style="border-radius: 10px;">
                      <!-- <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.desc !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template> -->
                    </v-textarea>

                  
                  
                    
                    
                  <!-- </ValidationProvider> -->

                  <!-- <div class="body-2 mb-2 mt-6">
                    Upload Gambar
                  </div> -->
                  <!-- <v-card flat width="200" height="200">
                    <v-card-title class="pa-0 text-center">

                      <v-img
                        :src="form.image_url !== undefined && form.image_url !== '' ? (cdnFallback['image_url'] ? getCdnLegacyDisplayUrl(form.image_url) : getCdnDisplayUrl(form.image_url)) : require('@/assets/image/member_default.png')"
                        @error="cdnFallback = { ...cdnFallback, 'image_url': true }"
                        width="200"
                        height="200"
                        :gradient="process.image ? `to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)` : ''"
                        style="border-radius: 16px; border: 2px solid #EBEBEB; 
                          border-style: dashed;">
                        <v-row
                          class="fill-height ma-0"
                          v-if="process.image"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </v-img>
                      <div class="mt-2">
                        <folder
                          v-model="upload.folder">
                          <div 
                            slot="activator">
                            <v-btn
                              class="text-capitalize white--text"
                              width="200"
                              height="40"
                              outlined
                              style="border-radius: 8px;"
                              :disabled="process.file"
                              color="grey darken-2"
                              elevation="0"
                            >
                              <v-icon dark size="22">
                                mdi-pencil
                              </v-icon>
                              Pilih Foto
                            </v-btn>
                          </div>
                        </folder>
                      </div>
                    </v-card-title>

                    <v-icon 
                      @click="form.image_url = ''"
                      color="red"
                      v-if="form.image_url !== ''"
                      class="cursor-pointer"
                      style="position: absolute; top: -10px; right: -10px;">
                      mdi-close-circle
                    </v-icon>
                  </v-card> -->
                  <!-- <folder v-if="form.image_url === ''"
                    v-model="upload.folder">
                    <div 
                      slot="activator">
                      <v-card 
                        flat
                        width="200"
                        height="200"
                        class="d-flex align-center justify-center cursor-pointer"
                        style="border-radius: 15px;
                              border: 2px solid #EBEBEB; 
                              border-style: dashed;">
                        <v-avatar v-if="!process.file"
                          v-ripple
                          tile 
                          width="200"
                          height="200">
                          <v-icon
                            size="50"
                            color="#B9B9B9">
                            mdi-cloud-upload-outline
                          </v-icon>
                        </v-avatar>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </folder> -->

                  <!-- <v-card v-if="form.image_url !== ''"
                    flat
                    width="200"
                    height="200"
                    class="d-flex align-center justify-center"
                    style="border-radius: 15px;
                          border: 2px solid #EBEBEB; 
                          border-style: dashed;">
                    <v-avatar
                      v-ripple
                      tile 
                      size="200"
                      style="border-radius: 15px;">
                      <v-img 
                        contain
                        width="100%"
                        height="100%"
                        alt="diskominfo" 
                        :src="cdnFallback['image_url'] ? getCdnLegacyDisplayUrl(form.image_url) : getCdnDisplayUrl(form.image_url)"
                        @error="cdnFallback = { ...cdnFallback, 'image_url': true }"
                        class="ma-auto"
                        style="border-radius: 15px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <v-icon 
                      @click="form.image_url = ''"
                      color="red"
                      class="cursor-pointer"
                      style="position: absolute; top: -10px; right: -10px;">
                      mdi-close-circle
                    </v-icon>
                  </v-card> -->

                  <div class="body-2 mb-2 mt-6">
                    <!-- <span class="red--text">*</span> -->
                    Upload File
                  </div>
                  <div v-if="form.image_url.length < 1 || form.image_url.split('.').pop() !== 'pdf'" style="width: 100%;">

                    <uploadImgPdf v-model="upload.file" style="height: 250px; width: 100%;">
                      <template #activator>
                        <v-card
                          flat
                          height="250"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px; border: 2px solid #eaeaea; border-style: dashed; width: 100%;">
                          
                          <div v-if="form.image_url.length < 1">
                            <v-icon v-if="!process.file" size="60" color="grey">
                              mdi-cloud-upload-outline
                            </v-icon>
    
                            <v-progress-circular v-else indeterminate :color="set_color" />
                          </div>
    
                          <v-img
                            v-else
                            contain
                            height="250"
                            :src="cdnFallback['image_url'] ? getCdnLegacyDisplayUrl(form.image_url) : getCdnDisplayUrl(form.image_url)"
                        @error="cdnFallback = { ...cdnFallback, 'image_url': true }"
                            :alt="form.image_url"
                            class="text-center d-flex align-center">
                            
                            <div class="d-flex align-center justify-center" style="width: 100%; height: auto;">
                              <v-icon v-if="!process.file" size="60" color="white">
                                mdi-cloud-upload-outline
                              </v-icon>
    
                              <v-progress-circular v-else indeterminate :color="set_color" />
                            </div>
                          </v-img>
                        </v-card>
                      </template>
                    </uploadImgPdf>
                  </div>

                  <div v-if="form.image_url.length > 0 && form.image_url.split('.').pop() === 'pdf'">
                    <iframe :src="cdnFallback['image_url'] ? getCdnLegacyDisplayUrl(form.image_url) : getCdnDisplayUrl(form.image_url)"
                        @error="cdnFallback = { ...cdnFallback, 'image_url': true }" height="250" width="100%" frameborder="0"></iframe>
                    <div class="pt-2">
                      <v-btn
                        elevation="0"
                        dark
                        block
                        @click="form.image_url = ''"
                        color="red"
                        rounded>
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>

                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Agenda
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="start"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center pb-1">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                class="fs-12 little-placeholder"
                style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
              </v-text-field>
              <v-btn
                color="#4B4B4B"
                elevation="0"
                small
                @click="dialog.form = true; reset();"
                min-height="30"
                class="fs-12 white--text text-capitalize d-flex align-center ml-3"
                style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                
                <span
                  class="ml-2">
                  Tambah
                </span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pegawai'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th :style="`background-color: ${set_color}; color: #fff;`" class="sticky-col one-col" style="z-index: 1;  color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'title' ? toSort('title') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Nama
                          <span v-if="sortBy === 'title'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'title' ? toSort('title') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Nama Pengguna
                          <span v-if="sortBy === 'dihadiri'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>  
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'start_date' ? toSort('start_date') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Tanggal Mulai
                          <span v-if="sortBy === 'start_date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'end_date' | date ? toSort('end_date' | date) : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tanggal Selesai
                          <span v-if="sortBy === 'end_date' | date">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'location' ? toSort('location') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Tempat
                          <span v-if="sortBy === 'location'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 120px; min-width: 120px; max-width: 120px; padding: 8px 2px; text-align: center;">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                
                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                @click="dialog.form = true; reset(index);"
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Ubah</span>
                          </v-tooltip>

                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toDelete(item.id)"

                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="red"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <span>Hapus</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.title }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.dihadiri }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.start_date | date }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.end_date  | date}}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 100%; padding: 8px 12px; text-align: left;">{{ item.location }}</td>
                        
                      </tr>
                    </table>
                  </div>
    
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
    
                  <v-card-text
                    v-if="!process.load && list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
    
                  <pagination v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)" 
                    @reloadPage="fetch($event)" 
                    :model="pagination" :display="paginationList"/>
    
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { getCdnDisplayUrl } from '@/utils/cdn'
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        cdnFallback: {}, // key -> true kalau proxy CDN gagal load, dipakai getCdnLegacyDisplayUrl
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false
        },
        
        search: '',

        filter: {
          
        },

        upload: {
          folder: null,
          file: null
        },
        

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: []
        },

        paginationList: {
          row: 20,
          page: 1
        },

        role: [],
        sortBy: 'id',
        sortDesc: '-',

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          title: '',
          start_date: '',
          end_date: '',
          start_time: '',
          end_time: '',
          desc: '',
          image_url: '',
          location: '',
          dihadiri: '',
          custom_opd: ''
        },

        unit: [],

        product: [],

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          export: false,
          form: false,
          file: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      uploadImgPdf: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document_pdf.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }

      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.image_url = this.upload.folder.data.full.file_url
              this.form.image_url = this.upload.folder.fullpath
            }
          }
        },
        deep: true
      },

      'upload.file': {
        handler: function () {
          console.log(this.upload.file)
          if (this.upload.file) {
            this.process.file = this.upload.file.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD PROPOSAL
              
              // this.form.file_url = this.upload.file.data.full.file_url
              this.form.image_url = this.upload.file.fullpath
              console.log(this.form.image_url)

              // this.save_proposal()
            }
          }
        },
        deep: true
      },

      'form.dihadiri': {
        handler: function (newVal) {
          // Clear custom_opd when a regular OPD is selected (not "Lainnya")
          if (newVal !== 'Lainnya') {
            this.form.custom_opd = ''
          }
        }
      },
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      unitWithOther () {
        // Add "Lainnya" option to the unit list
        return [
          ...this.unit,
          { title: 'Lainnya' }
        ]
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
    },
    mounted () {
      this.fetch()
      this.fetchUnit()
      this.fetchProduct()
    },
    methods: {
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },

      async fetchProduct () {
        let params = {
          limit: 1000000
        }
        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.product = res.results.data
          }
        })
      },

      async fetchUnit () {
        let params = {
          limit: 1000000,
          'type[neq]': 'Desa'
        }
        await get(`https://api.klaten.go.id/sites/profile/unit`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          'title[lse]': this.search
        }

        this.selected.row = []

        await get(`admin/agenda/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '150px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Status',
              //   width: '100px',
              //   value: 'is_active',
              //   freeze: false,
              //   hide: false,
              //   align: 'center',
              //   format: 'bool'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Genda',
                width: '300px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Kategori Pegawai',
                width: '200px',
                value: 'cat_title',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '200px',
                value: 'mobilephone',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Jenis Kelamin',
              //   width: '200px',
              //   value: 'gender',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Nama Outlet',
              //   width: '400px',
              //   value: 'outlet_name',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Dibuat Tanggal',
                width: '100%',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.list.map(obj => {
              obj.is_active = obj.is_active === '1' ? true : false
            })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        // Check if dihadiri is in unit list, if not it's a custom OPD
        let dihadiri = index !== undefined ? this.list[index].dihadiri : ''
        let isCustomOpd = dihadiri !== '' && !this.unit.some(u => u.title === dihadiri)
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          title: index !== undefined ? this.list[index].title : '',
          start_date: index !== undefined ? this.list[index].start_date : '',
          end_date: index !== undefined ? this.list[index].end_date : '',
          start_time: index !== undefined ? this.list[index].start_time : '',
          end_time: index !== undefined ? this.list[index].end_time : '',
          image_url: index !== undefined ? this.list[index].image_url : '',
          desc: index !== undefined ? this.list[index].desc : '',
          location: index !== undefined ? this.list[index].location : '',
          dihadiri: isCustomOpd ? 'Lainnya' : dihadiri,
          custom_opd: isCustomOpd ? dihadiri : ''
        }

        this.process.form = false

        this.message.error = ''

        // if (this.dialog.form) 
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          // if (this.form.id === '') {
          //   this.list.push(
          //     {
          //       id: this.list.length,
          //       title: this.form.title,
          //       start_date: this.form.start_date,
          //       end_date: this.form.end_date,
          //       start_time: this.form.start_time,
          //       end_time: this.form.end_time,
          //       desc: this.form.desc,
          //       image_url: this.form.image_url
          //     }
          //   )
          // } else {
          //   this.list[this.form.id] = {
          //     id: this.form.id,
          //     title: this.form.title,
          //     start_date: this.form.start_date,
          //     end_date: this.form.end_date,
          //     start_time: this.form.start_time,
          //     end_time: this.form.end_time,
          //     desc: this.form.desc,
          //     image_url: this.form.image_url
          //   }
          // }
          // this.dialog.form = false

          // this.dialog.snackbar = true
          // this.message.success = this.form.id === '' ? 'Berhasil Menambah Agenda' : 'Berhasil Mengubah Agenda'

          // this.dialog.fullscreen = false

          // this.reset()

          // this.fetch()

          let url = this.form.id === '' ? 'admin/agenda/add' : 'admin/agenda/update'

          // Prepare form data - use custom_opd if "Lainnya" is selected
          let formData = { ...this.form }
          if (formData.dihadiri === 'Lainnya') {
            formData.dihadiri = formData.custom_opd
          }

          // SAVE TO REST API
          await post(url, {
            data: formData
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/agenda/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper-pegawai { 
  overflow-y: auto; 
  height: calc(100vh - 265px); 
} 

.wrapper-pegawai-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper-pegawai th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>